import CommonError from '../Common/CommonError'

const Error503Container = () => {
  return (
    <CommonError color="primary" src="6" />
  )
}

export default Error503Container